function isComponent(component) {
    return (typeof component === 'function' &&
        'cid' in component);
}

var ThunkState;
(function (ThunkState) {
    ThunkState[ThunkState["Pending"] = 0] = "Pending";
    ThunkState[ThunkState["Fulfilled"] = 1] = "Fulfilled";
    ThunkState[ThunkState["Rejected"] = 2] = "Rejected";
})(ThunkState || (ThunkState = {}));
var DEFAULT_THUNK_ERROR = new Error('thunk rejected');
function thunk(exeuctor) {
    var value;
    var reason;
    var state = ThunkState.Pending;
    var handlers;
    try {
        exeuctor(function (v) {
            state || (state = ThunkState.Fulfilled);
            value = v;
            notify(null, value);
        }, function (r) {
            state || (state = ThunkState.Rejected);
            reason = r !== null && r !== void 0 ? r : DEFAULT_THUNK_ERROR;
            notify(reason);
        });
    }
    catch (e) {
        state || (state = ThunkState.Rejected);
        reason = e;
        notify(reason);
    }
    return function (callback) {
        switch (state) {
            case ThunkState.Rejected:
                callback(reason);
                break;
            case ThunkState.Fulfilled:
                callback(null, value);
                break;
            default:
                (handlers !== null && handlers !== void 0 ? handlers : (handlers = [])).push(callback);
                break;
        }
    };
    function notify(arg1, arg2) {
        if (handlers) {
            for (var _i = 0, handlers_1 = handlers; _i < handlers_1.length; _i++) {
                var handler = handlers_1[_i];
                handler === null || handler === void 0 ? void 0 : handler(arg1, arg2);
            }
            handlers.length = 0;
            handlers = undefined;
        }
    }
}
thunk.resolve = thunkResolve;
thunk.reject = thunkReject;
function thunkResolve(value) {
    return function (callback) { return callback(null, value); };
}
function thunkReject(reason) {
    if (reason === void 0) { reason = DEFAULT_THUNK_ERROR; }
    return function (callback) { return callback(reason); };
}

var noop = function () { };
function intercept(target, propertyKey, handlers) {
    var _a, _b, _c;
    var prevDesc = Object.getOwnPropertyDescriptor(target, propertyKey);
    if (prevDesc && !prevDesc.configurable) {
        return noop;
    }
    Object.defineProperty(target, propertyKey, {
        get: (handlers.get ?
            function () {
                var $super = {
                    get: function (target) { var _a; return (_a = prevDesc === null || prevDesc === void 0 ? void 0 : prevDesc.get) === null || _a === void 0 ? void 0 : _a.call(target); }
                };
                return handlers.get(this, $super);
            } :
            (_a = prevDesc === null || prevDesc === void 0 ? void 0 : prevDesc.get) !== null && _a !== void 0 ? _a : noop),
        set: (handlers.set ?
            function (value) {
                var $super = {
                    set: function (target, value) { var _a; return (_a = prevDesc === null || prevDesc === void 0 ? void 0 : prevDesc.set) === null || _a === void 0 ? void 0 : _a.call(target, value); }
                };
                handlers.set(this, value, $super);
            } :
            (_b = prevDesc === null || prevDesc === void 0 ? void 0 : prevDesc.set) !== null && _b !== void 0 ? _b : noop),
        enumerable: (_c = prevDesc === null || prevDesc === void 0 ? void 0 : prevDesc.enumerable) !== null && _c !== void 0 ? _c : false,
        configurable: true,
    });
    return function () {
        // reset
        if (prevDesc) {
            Object.defineProperty(target, propertyKey, prevDesc);
        }
        else {
            // @ts-ignore
            delete target[propertyKey];
        }
    };
}

function getSuperComponentByClass(component) {
    // @ts-ignore
    return component['super'];
}

function isVue(component) {
    // @ts-ignore
    return isComponent(component) && component.cid === 0;
}

function getVue() {
    return thunk(function (resolve, reject) {
        var teardown = intercept(Object.prototype, '_isVue', {
            set: function (target, value, $super) {
                $super.set(target, value);
                if (target !== Object.prototype) {
                    Object.defineProperty(target, '_isVue', {
                        value: value,
                        writable: true,
                        enumerable: false,
                        configurable: true,
                    });
                }
                if (value !== true) {
                    return;
                }
                teardown();
                var klass = target.constructor;
                while (!isVue(klass)) {
                    var superComponent = getSuperComponentByClass(klass);
                    if (!superComponent) {
                        break;
                    }
                    klass = superComponent;
                }
                var Vue = klass;
                if (!Object.getOwnPropertyDescriptor(Vue.prototype, '_isVue')) {
                    Object.defineProperty(Vue.prototype, '_isVue', {
                        get: function () {
                            return true;
                        },
                        set: function (value) {
                            if (this !== Vue.prototype) {
                                Object.defineProperty(this, '_isVue', {
                                    value: value,
                                    writable: true,
                                    enumerable: false,
                                    configurable: true,
                                });
                            }
                        }
                    });
                }
                resolve(Vue);
            },
        });
    });
}

function initStartLocation(router, location) {
    if (router.options.base) {
        var baseLowerCase = router.options.base.toLowerCase();
        var pathLowerCase = location.toLowerCase();
        if (!/\/$/.test(baseLowerCase)) {
            baseLowerCase = "".concat(baseLowerCase, "/");
        }
        if (pathLowerCase.substring(0, baseLowerCase.length) === baseLowerCase) {
            pathLowerCase = pathLowerCase.substring(baseLowerCase.length);
        }
        location = pathLowerCase;
    }
    // @ts-ignore
    router.history._startLocation = location;
}

function __dangerouslySaveAppByRouter(router, app) {
    if (router.app) {
        return;
    }
    // not installed
    Object.defineProperty(app, '$router', {
        get: function () {
            return router;
        },
        enumerable: true,
        configurable: true,
    });
    // @ts-ignore
    router._app = app;
}
function __dangerouslyGetAppByRouter(router) {
    var _a;
    if (router.app) {
        return router.app;
    }
    // @ts-ignore
    var app = router._app;
    if (app) {
        (_a = app.$on) === null || _a === void 0 ? void 0 : _a.call(app, 'hook:beforeCreate', function () {
            // @ts-ignore
            delete router._app;
        });
    }
    return app;
}

function getVueRouter() {
    var _a = window.location, pathname = _a.pathname, search = _a.search, hash = _a.hash;
    var startLocation = "".concat(pathname).concat(search).concat(hash);
    return thunk(function (resolve, reject) {
        var vueThunk = getVue();
        var intercepted = false;
        var installed = false;
        vueThunk(function (err, Vue) {
            if (err) {
                reject(err);
                return;
            }
            if (intercepted) {
                return;
            }
            intercepted = true;
            var router;
            Vue.mixin({
                beforeCreate: function () {
                    if (router) {
                        return;
                    }
                    // already init router
                    try {
                        router = this.$router;
                    }
                    catch (err) {
                    }
                    if (router) {
                        installed = true;
                    }
                    router !== null && router !== void 0 ? router : (router = this.$options.router);
                    if (router) {
                        if (!installed) {
                            initStartLocation(router, startLocation);
                            __dangerouslySaveAppByRouter(router, this);
                        }
                        resolve(router);
                    }
                }
            });
        });
    });
}

function getAppRoot(options) {
    if (options === void 0) { options = {}; }
    if ((options === null || options === void 0 ? void 0 : options.router) === 'ignore') {
        var vueThunk_1 = getVue();
        return function (callback) {
            vueThunk_1(function (err, Vue) {
                if (err) {
                    callback(err);
                    return;
                }
                var available = false;
                Vue.mixin({
                    beforeCreate: function () {
                        if (available) {
                            return;
                        }
                        available = true;
                        callback(null, this.$root);
                    }
                });
            });
        };
    }
    var routerThunk = getVueRouter();
    return function (callback) {
        routerThunk(function (err, router) {
            if (err) {
                callback(err);
                return;
            }
            callback(null, __dangerouslyGetAppByRouter(router));
        });
    };
}

export { getAppRoot, intercept, thunk };
//# sourceMappingURL=index.esm.js.map
